/**
 * One row of what a FAIL does, drawn like an "Only when" row: what it is
 * (in the metric box's place), its controls, and the ⓘ.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC, ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

import { HintDot } from '@/components/ui';

/** The choice buttons at row height. */
export const COMPACT_CHOICE = 'flex items-center [&_[role=radio]]:h-7 [&_[role=radio]]:gap-1.5 [&_[role=radio]]:px-2.5 [&_[role=radio]]:text-xs';
export const NUMBER_FIELD = 'h-8 w-20 rounded-md border border-input bg-background px-2 text-right font-mono text-xs tabular-nums focus:outline-none focus:ring-1 focus:ring-ring';

export const ConsequenceRow: FC<{ icon: LucideIcon; label: string; hint: string; testId: string; children: ReactNode }> = ({ icon: Icon, label, hint, testId, children }) => (
  <div className="flex min-w-0 flex-wrap items-center gap-2 rounded-md border border-border bg-card/60 px-2 py-1.5 text-xs duration-200 animate-in fade-in-0 motion-reduce:animate-none" data-testid={testId}>
    <span className="inline-flex h-8 w-36 shrink-0 items-center gap-1.5 rounded-md border border-border/60 bg-muted/30 px-2 font-medium">
      <Icon className="h-3.5 w-3.5 shrink-0 text-muted-foreground" aria-hidden />
      {label}
    </span>
    {children}
    <HintDot label={hint} />
  </div>
);
